import CancersTemplate from "components/templates/CancersTemplate/CancersTemplate";

const CancersPage = () => {
  return <CancersTemplate />;
};

export default CancersPage;
